import { render } from "./HomeAcademic.vue?vue&type=template&id=540319c0"
import script from "./HomeAcademic.vue?vue&type=script&lang=js"
export * from "./HomeAcademic.vue?vue&type=script&lang=js"

import "./HomeAcademic.vue?vue&type=style&index=0&id=540319c0&lang=scss"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__